import type { CompletionResult } from "../BookShipmentProcessingScreen";
import { BookShipmentBookingProgressBar } from "../Bars/BookShipmentBookingProgressBar";

interface BookingInProgressProps {
  onComplete?: ((result: CompletionResult) => void) | undefined;
  isComplete?: boolean | undefined;
}

function BookShipmentBookingInProgress({
  onComplete,
  isComplete,
}: BookingInProgressProps) {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "var(--color-card)",
        padding: "20px",
      }}
    >
      <BookShipmentBookingProgressBar
        onComplete={onComplete}
        isComplete={isComplete}
      />
    </div>
  );
}
export default BookShipmentBookingInProgress;
